// import MaterialTable from 'material-table'
import React, { useEffect } from 'react'
import { Autocomplete, Box, Button, Checkbox, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import Service from '../Networking/NetworkingUtils';
import { useSnackbar } from 'notistack';
import { getCookie } from '../Utils/CookieHelper';
import dayjs from 'dayjs';
import Divider from '@mui/material/Divider';
import moment from 'moment';
import ProjectAccessList from './ProjectAccessList';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AddBoxIcon from '@mui/icons-material/AddBox';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import UserProjectAccess from './UserProjectAccess';

const token = getCookie("bb_metaverse_token");
var userCookie = JSON.parse(getCookie('bb_metaverse_user'))
// const dark = getCookie('theme_mode')


const UserAccess = (props) => {

    const [addDialog, setAddDialog] = React.useState(false)
    const [users, setUsers] = React.useState([])
    const [user, setUser] = React.useState('')
    const [loading, setLoading] = React.useState(true)
    const [tableData, setTableData] = React.useState([])
    const { enqueueSnackbar } = useSnackbar();
    const [checked, setChecked] = React.useState(false)
    const [startDate, setStartDate] = React.useState(null)
    const [endDate, setEndDate] = React.useState(null)
    const [addUserDisabled, setAddUserDisabled] = React.useState(false)
    const [left, setLeft] = React.useState([])
    const [right, setRight] = React.useState([])
    const [groupAccessLeft, setGroupAccessLeft] = React.useState([])
    const [groupAccessRight, setGroupAccessRight] = React.useState([])
    const [accessLeft, setAccessLeft] = React.useState([])
    const [accessRight, setAccessRight] = React.useState([])
    const [accessObj, setAccessObj] = React.useState({})
    const [open] = React.useState(false)
    const [lookup, setLookup] = React.useState({})
    const initialRender = React.useRef(true);
    const [rowData, setRowData] = React.useState({})
    const [columns] = React.useState([
        { title: 'Name', field: 'user_details', editable: 'never', render: rowData => rowData.user_details.last_name + ", " + rowData.user_details.first_name },
        // { title: 'Stakeholder', field: 'stakeholder', type: 'boolean', render: rowData => rowData.stakeholder ? <CheckIcon/> : <HorizontalRuleIcon/> },
        { title: 'Unlimited', field: 'is_unlimited', lookup: { true: 'True', false: 'False' } },
        { title: 'Start Date', field: 'start_date', type: 'date', validate: rowData => moment(rowData.start_date) >= moment(rowData.end_date) ? 'Start Date should be lower than End Date' : '' },
        { title: 'End Date', field: 'end_date', type: 'date', validate: rowData => moment(rowData.start_date) >= moment(rowData.end_date) ? 'End Date should be greater than Start Date' : '' }
    ])
    const [isEdit] = React.useState(false)
    const [editData, setEditData] = React.useState({})
    const [editRowId, setEditRowId] = React.useState(null);
    const [editRowData, setEditRowData] = React.useState({});

    function handleAddUserClose() {
        setAddDialog(false)
    }

    function addUser() {

        if (!user) {
            enqueueSnackbar('Please Select User', {
                variant: 'warning'
            });
            return null
        }

        if (!checked) {
            if ((!startDate && !endDate)) {
                enqueueSnackbar('you have to select either unlimited or start and end date', {
                    variant: 'warning'
                });
            } else if (!startDate || !endDate) {
                enqueueSnackbar('Please choose both start date and end date', {
                    variant: 'warning'
                });
            }
            else {
                let data = {
                    "start_date": dayjs(startDate).format('YYYY-MM-DD'),
                    "end_date": dayjs(endDate).format('YYYY-MM-DD'),
                    "is_unlimited": false,
                    "user": user.id,
                    "project": props.project.id,
                    "created_by": userCookie.id
                }
                postUserAccess(data)
            }
        } else {

            let data = {
                "start_date": null,
                "end_date": null,
                "is_unlimited": true,
                "user": user.id,
                "project": props.project.id,
                "created_by": userCookie.id
            }
            postUserAccess(data)
        }

        function postUserAccess(data) {
            setAddUserDisabled(true)
            Service.post(`/api/projects/access/create_project_level_access/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data
            })
                .then(res => {
                    enqueueSnackbar('User Added Successfully', {
                        variant: 'success'
                    });
                    setAddDialog(false)
                    setChecked(false)
                    setUser(null)
                    setStartDate(null)
                    setEndDate(null)
                    setAddUserDisabled(false)
                    getTableData()
                })
                .catch(error => {
                    console.log(error)
                    setAddUserDisabled(false)
                    enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }

    function getUsers(data) {
        Service.get('/api/users/get_user/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let existUserIDs = []
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    existUserIDs.push(element.user)
                }
                let users = []
                for (let index = 0; index < res.data.length; index++) {
                    const element = res.data[index];
                    if (!existUserIDs.includes(element.id)) {
                        users.push(element)
                    }
                }
                setUsers(users)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    function getTableData(index) {
        setLoading(true)
        Service.get(`/api/projects/level/access/get_project_level_useraccess/?project=${props.project.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let data = res.data
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    element.open = false
                }
                if (index) {
                    let individualAccessLeft = []
                    let individualAccessRight = []
                    let groupLeft = []
                    let groupRight = []
                    let element = res.data.find(element => element.id === index)
                    element.open = true
                    Object.keys(element.direct_access_data).forEach(key => {
                        if (element.direct_access_data[key] === true) {
                            individualAccessRight.push(key)
                        } else {
                            individualAccessLeft.push(key)
                        }
                    })
                    setAccessLeft(individualAccessLeft)
                    setAccessRight(individualAccessRight)
                    Object.keys(element.group_access_data).forEach(key => {
                        if (element.group_access_data[key] === true) {
                            groupRight.push(key)
                        } else {
                            groupLeft.push(key)
                        }
                    })
                    setGroupAccessLeft(groupLeft)
                    setGroupAccessRight(groupRight)
                }
                console.log(data)
                setTableData(data)
                getUsers(data)
                setLoading(false)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    function openDialog() {
        setAddDialog(true)
    }

    function closeUserDialog() {
        setAddDialog(false)
        setChecked(false)
        setUser(null)
        setStartDate(null)
        setEndDate(null)
    }

    function editUserAccess(rowData) {
        if (rowData.is_unlimited === "true") {
            rowData.start_date = null
            rowData.end_date = null
            editFunc(rowData)
        } else if (rowData.is_unlimited === "false") {
            if (rowData.start_date === null || rowData.end_date === null) {
                enqueueSnackbar('Start Date and End Date cannot be empty if Unlimited is false', {
                    variant: 'warning'
                });
            } else if (moment(rowData.start_date) >= moment(rowData.end_date)) {
                enqueueSnackbar('Start Date should be lower than end Date', {
                    variant: 'warning'
                });
            }
            else {
                rowData.start_date = rowData.start_date ? dayjs(rowData.start_date).format('YYYY-MM-DD') : null
                rowData.end_date = rowData.end_date ? dayjs(rowData.end_date).format('YYYY-MM-DD') : null
                editFunc(rowData)
            }
        }
        else {
            rowData.start_date = rowData.start_date ? dayjs(rowData.start_date).format('YYYY-MM-DD') : null
            rowData.end_date = rowData.end_date ? dayjs(rowData.end_date).format('YYYY-MM-DD') : null
            editFunc(rowData)
        }
    }

    function editFunc(rowData) {
        Service.patch(`/api/projects/access/update_project_access/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: rowData
        })
            .then(res => {
                enqueueSnackbar('Access Updated Succesfully', {
                    variant: 'success'
                });
                setChecked(false)
                setStartDate(null)
                setEndDate(null)
                getTableData()
                setAddDialog(false)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    function deleteUserAccess(rowData) {
        Service.delete(`/api/projects/access/delete_project_access/?id=` + rowData.id, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                enqueueSnackbar('Access Deleted Succesfully', {
                    variant: 'success'
                });
                setChecked(false)
                setStartDate(null)
                setEndDate(null)
                getTableData()
            })
            .catch(error => {
                console.log(error)
                if (error.status === 406) {
                    enqueueSnackbar(error?.data?.msg, {
                        variant: 'warning'
                    });
                } else {
                    enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            });
    }

    function handleAccess(left, right, rowData) {
        setLeft(left)
        setRight(right)
        for (let index = 0; index < tableData.length; index++) {
            const element = tableData[index];
            if (element?.id === rowData?.id) {
                element.access_data = {}
                for (const key in lookup) {
                    if (left.includes(key)) {
                        element.access_data[key] = false
                    } else if (right.includes(key)) {
                        element.access_data[key] = true
                    }
                }
            }
        }
    }

    function getAcess() {
        Service.get(`/api/projects/access/list/get_project_access_list/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let obj = {}
                for (let index = 0; index < res.data.length; index++) {
                    const element = res.data[index];
                    element.isChecked = false
                    obj[element.access_key] = element.name
                }
                setLookup(obj)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    useEffect(() => {
        getTableData()
        getAcess()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            if (!open) {
                setLoading(true)
                getTableData()
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const reloadData = () => {
        setLoading(true)
        getTableData(rowData.id)
    }

    return (
        <div style={{ width: '100%' }}>
            {/* Table with row click to expand ProjectAccessList */}
            {loading ? <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width='100%'><CircularProgress /></Box> :
                <TableContainer component={Paper}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' width='100%' paddingX={2}>
                        <Typography variant="h5">{props.project.name}</Typography>
                        <Box>
                            <Button onClick={() => openDialog()}><Tooltip title="Add"><AddBoxIcon /></Tooltip></Button>
                        </Box>
                    </Box>
                    <React.Fragment>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {/* <TableCell /> */}
                                    {columns && columns.map((column) => (
                                        <TableCell key={column.field}>{column.title}</TableCell>
                                    ))}
                                    <TableCell align='center'>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData && tableData.map((row, idx) => (
                                    <React.Fragment key={row.id}>
                                        <TableRow
                                            onClick={() => {
                                                // Toggle open for this row only
                                                const updatedTableData = tableData.map((r, i) => {
                                                    if (i === idx) {
                                                        return { ...r, open: !r.open };
                                                    } else {
                                                        return { ...r, open: false };
                                                    }
                                                });
                                                setTableData(updatedTableData);
                                                setRowData(row);
                                                // Set left/right based on access_data for this row
                                                const leftList = [];
                                                const rightList = [];
                                                const groupLeftList = [];
                                                const groupRightList = [];
                                                const accessLeftList = [];
                                                const accessRightList = [];
                                                if (row.access_data) {
                                                    Object.entries(row.access_data).forEach(([key, value]) => {
                                                        if (value === true) {
                                                            rightList.push(key);
                                                        } else {
                                                            leftList.push(key);
                                                        }
                                                    });
                                                }
                                                if(row.group_access_data){
                                                    Object.entries(row.group_access_data).forEach(([key, value]) => {
                                                        if (value === true) {
                                                            groupRightList.push(key);
                                                        } else {
                                                            groupLeftList.push(key);
                                                        }
                                                    });
                                                }
                                                if(row.direct_access_data){
                                                    let obj = {}
                                                    Object.entries(row.direct_access_data).forEach(([key, value]) => {
                                                        let nameCapitalize = key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
                                                        obj[key] = nameCapitalize
                                                        if (value === true) {
                                                            accessRightList.push(key);
                                                        } else {
                                                            accessLeftList.push(key);
                                                        }
                                                    });
                                                    setAccessObj(obj)
                                                }
                                                setLeft(leftList);
                                                setRight(rightList);
                                                setGroupAccessLeft(groupLeftList);
                                                setGroupAccessRight(groupRightList);
                                                setAccessLeft(accessLeftList);
                                                setAccessRight(accessRightList);
                                            }}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            {columns && columns.map((column) => (
                                                <TableCell key={column.field}  >
                                                    {editRowId === row.id ? (
                                                        // column.field === 'stakeholder' ? (
                                                        //     <Checkbox
                                                        //         color='primary'
                                                        //         checked={!!editRowData.stakeholder}
                                                        //         onChange={e => setEditRowData({ ...editRowData, stakeholder: e.target.checked })}
                                                        //     />
                                                        // ) : 
                                                        column.field === 'is_unlimited' ? (
                                                            <Checkbox
                                                                color='primary'
                                                                checked={!!editRowData.is_unlimited}
                                                                onChange={e => setEditRowData({ ...editRowData, is_unlimited: e.target.checked })}
                                                            />
                                                        ) : column.field === 'start_date' ? (
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    format='DD/MM/YYYY'
                                                                    label="Start Date"
                                                                    value={editRowData.start_date ? dayjs(editRowData.start_date) : null}
                                                                    onChange={newValue => setEditRowData({ ...editRowData, start_date: dayjs(newValue).format('YYYY-MM-DD') })}
                                                                />
                                                            </LocalizationProvider>
                                                        ) : column.field === 'end_date' ? (
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    format='DD/MM/YYYY'
                                                                    label="End Date"
                                                                    value={editRowData.end_date ? dayjs(editRowData.end_date) : null}
                                                                    onChange={newValue => setEditRowData({ ...editRowData, end_date: dayjs(newValue).format('YYYY-MM-DD') })}
                                                                />
                                                            </LocalizationProvider>
                                                        ) : column.render ? column.render(editRowData) : column.lookup ? column.lookup[editRowData[column.field]] : editRowData[column.field]
                                                    ) : (
                                                        column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]
                                                    )}
                                                </TableCell>
                                            ))}
                                            <TableCell>
                                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                                    {editRowId === row.id ? (
                                                        <>
                                                            <IconButton color="primary" size="small" onClick={e => {
                                                                e.stopPropagation();
                                                                editUserAccess(editRowData);
                                                                setEditRowId(null);
                                                            }}><CheckIcon /></IconButton>
                                                            <IconButton color="secondary" size="small" onClick={e => {
                                                                e.stopPropagation();
                                                                setEditRowId(null);
                                                            }}><CloseIcon /></IconButton>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Tooltip title="Edit">
                                                                <IconButton onClick={e => {
                                                                    e.stopPropagation();
                                                                    setEditRowId(row.id);
                                                                    setEditRowData(row);
                                                                }}><EditIcon /></IconButton>
                                                            </Tooltip>
                                                            {row.is_deletable && (
                                                                <Tooltip title="Delete">
                                                                    <IconButton onClick={e => {
                                                                        e.stopPropagation();
                                                                        deleteUserAccess(row);
                                                                    }}><DeleteIcon /></IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </>
                                                    )}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                <Collapse in={row.open} timeout="auto" unmountOnExit>
                                                    <Box display={'flex'} flexDirection='column'>
                                                        <Box margin={2}>
                                                            <UserProjectAccess
                                                                left={left}
                                                                right={right}
                                                                access={rowData}
                                                                open={row.open}
                                                                accessCallback={handleAccess}
                                                                lookup={lookup}
                                                            />
                                                        </Box>
                                                        <Box margin={2}>
                                                            <ProjectAccessList
                                                                accessObj={accessObj}
                                                                groupedAccess={true}
                                                                project={props.project}
                                                                title={"Group Access"}
                                                                left={groupAccessLeft}
                                                                right={groupAccessRight}
                                                                access={rowData}
                                                                open={row.open}
                                                                callBack={reloadData}
                                                                lookup={lookup}
                                                            />
                                                        </Box>
                                                        <Box margin={2}>
                                                            <ProjectAccessList
                                                                accessObj={accessObj}
                                                                groupedAccess={false}
                                                                project={props.project}
                                                                title={"Direct Access"}
                                                                left={accessLeft}
                                                                right={accessRight}
                                                                access={rowData}
                                                                open={row.open}
                                                                callBack={reloadData}
                                                                lookup={lookup}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </React.Fragment>
                </TableContainer>}
            <Dialog maxWidth="xs" fullWidth={true} open={addDialog} onClose={handleAddUserClose} disableEnforceFocus>
                <DialogTitle marginTop="2px" spacing={2}>{isEdit ? 'Edit User' : 'Add User'}</DialogTitle>
                <DialogContent>
                    <Box mt={1} sx={{ display: 'flex', flexDirection: "column" }}>
                        <Box sx={{ display: 'flex', flexDirection: "row", justifyContent: 'center' }}>
                            <Autocomplete
                                disablePortal
                                id="users"
                                value={isEdit ? editData.user_details : user}
                                options={users}
                                getOptionLabel={(option) => option ? option['last_name'] + ", " + option['first_name'] : ''}
                                renderInput={(params) => <TextField variant='outlined' {...params} label="Users" />}
                                onChange={(event, values) => {
                                    if (isEdit) {
                                        let user = editData
                                        user.user_details = values
                                        user.user = values.id
                                        setEditData(user)
                                    } else {
                                        setUser(values)
                                    }
                                }}
                                fullWidth
                            />
                        </Box>

                        <Box sx={{ mt: 2, display: 'flex', flexDirection: "column" }}>
                            <Box>
                                <FormControlLabel
                                    label="Unlimited"
                                    control={
                                        <Checkbox
                                            checked={isEdit ? editData.is_unlimited : checked}
                                            onChange={() => {
                                                if (isEdit) {
                                                    let user = editData
                                                    user.is_unlimited = !user.is_unlimited
                                                    if (user.is_unlimited) {
                                                        user.start_date = null
                                                        user.end_date = null
                                                    }
                                                    setEditData(user)
                                                } else {
                                                    setChecked(!checked)
                                                }
                                            }}
                                        />
                                    }
                                />
                            </Box>
                            <Divider orientation="horizontal" flexItem >
                                OR
                            </Divider>
                            <Box mt={1}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            format='DD/MM/YYYY'
                                            margin="normal"
                                            id="date-picker-dialog"
                                            inputVariant="outlined"
                                            label="Start Date"
                                            value={isEdit ? editData.startDate : startDate}
                                            onChange={(newValue) => {
                                                if (isEdit) {
                                                    let user = editData
                                                    user.start_date = newValue
                                                    setEditData(user)
                                                } else {
                                                    setStartDate(newValue)
                                                }
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            format='DD/MM/YYYY'
                                            margin="normal"
                                            id="date-picker-dialog"
                                            inputVariant="outlined"
                                            label="End Date"
                                            value={isEdit ? editData.endDate : endDate}
                                            onChange={(newValue) => {
                                                if (isEdit) {
                                                    let user = editData
                                                    user.end_date = newValue
                                                    setEditData(user)
                                                } else {
                                                    setEndDate(newValue)
                                                }
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="text" onClick={() => closeUserDialog()}>Cancel</Button>
                    <Button color="primary" variant="text" onClick={(e) => { isEdit ? editUserAccess(editData) : addUser() }} disabled={addUserDisabled}>{isEdit ? 'Edit' : 'Add'}</Button>
                </DialogActions>
            </Dialog>
        </div >
    )
}

// export default withSnackbar(UserAccess)
export default UserAccess;